import type { GlobalSearchActionUI } from './../global-search-models'
import type { GlobalSearchResultItem } from './../../../extensions/global-search-extension'
import {
  SVG_BADGE_OUTLINED,
  SVG_MESSAGE_OUTLINED,
  SVG_PHONE_UP_ACTIVE,
  SVG_WEBCAM_ON_OUTLINED,
} from '@getgo/chameleon-icons'

export const NUMBER_OF_PREVIEW_ITEMS = 5

export const mockSearchString = '456'

const callAction = {
  id: 'action id',
  displayName: 'call',
  icon: SVG_PHONE_UP_ACTIVE,
  command: { namespace: 'call', commandName: 'callPhone' },
}

const messageAction = {
  id: 'action id',
  displayName: 'message',
  icon: SVG_MESSAGE_OUTLINED,
  command: { namespace: 'message', commandName: 'sendMessage' },
}

const videoAction = {
  id: 'action id',
  displayName: 'video',
  icon: SVG_WEBCAM_ON_OUTLINED,
  command: { namespace: 'video', commandName: 'startMeeting' },
}

export const mockSingleSearchResult = [
  {
    userKey: 'result1',
    title: 'Kermit The Frog',
    preview: '123-456-7890',
    actions: [callAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
]

export const mockSearchResults = [
  {
    userKey: 'result1',
    title: 'Kermit The 456 Frog',
    preview: '123-456-7890',
    actions: [callAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result2',
    title: '456Miss Piggy',
    preview: '123-456-7890',
    actions: [messageAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result3',
    title: 'Fozzie Bear456',
    preview: 'really456incrediblyextremelylongemailaddress@superlongemailaddressdomainnamewebsite.com',
    actions: [videoAction, messageAction, callAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    title: 'Number One Winner',
    preview: '123-456-7890',
    actions: [callAction],
    icon: SVG_BADGE_OUTLINED,
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    externalUserKey: 'result2',
    title: 'This contact has a very long name this time and this is it wow it just keeps going I cannot believe it',
    preview: '123-456-7890',
    actions: [messageAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result3',
    title: 'Fozzie Bear',
    preview: 'reallylongemailaddress@superlongemailaddress.com',
    actions: [videoAction, messageAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result1',
    title: 'Kermit The Frog',
    preview: '123-456-7890',
    actions: [callAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result2',
    title: 'Miss Piggy',
    preview: '123-456-7890',
    actions: [messageAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
  {
    userKey: 'result3',
    title: 'Fozzie Bear',
    preview: '123-456-7890',
    actions: [videoAction],
    originalResult: {} as GlobalSearchResultItem,
    defaultAction: {} as GlobalSearchActionUI,
  },
]

export const mockSearchResultPreviewItemExternalUserKey = {
  userKey: '123456789',
  title: 'Carly Rae Jepsen',
  preview: 'Call me maybe',
  actions: [callAction],
  originalResult: {} as GlobalSearchResultItem,
  defaultAction: callAction,
}

export const mockSearchResultPreviewItemIcon = {
  icon: SVG_BADGE_OUTLINED,
  title: 'Carly Rae Jepsen',
  preview: 'Call me maybe',
  actions: [callAction, messageAction],
  originalResult: {} as GlobalSearchResultItem,
  defaultAction: {} as GlobalSearchActionUI,
}

export const mockSearchResultPreviewNoActions = {
  icon: SVG_BADGE_OUTLINED,
  title: 'Carly Rae Jepsen',
  preview: 'Call me maybe',
  actions: [],
  originalResult: {} as GlobalSearchResultItem,
  defaultAction: {} as GlobalSearchActionUI,
}
